import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TypeEventOperationHistory } from "@edp-enums/type-event-operation.enum";
import { NewModalService } from "@edp-pages/requests-and-operations/services/new-modal.service";
import { EdpPaymentAgreementService } from "@edp-services/edp-payment-agreement.service";
import { PaymentService } from "@edp-services/payment.service";

@Component({
    selector: "current-payment-agreement",
    templateUrl: "./current-payment-agreement.component.html",
    styleUrls: ["./current-payment-agreement.component.scss"],
})
export class CurrentPaymentAgreementComponent implements OnInit {
    private isLogged: boolean;

    constructor(
        private edpPaymentAgreementService: EdpPaymentAgreementService,
        private readonly newModalService: NewModalService,
        private router: Router,
        private paymentService: PaymentService
    ) {
        this.isLogged = this.edpPaymentAgreementService.getBottomBarValue();
    }

    ngOnInit() {
        this.setOperationHistory(TypeEventOperationHistory.VIEWEXISTINGAGREEMENT);
    }

    onAgreementGenerate() {
        this.setOperationHistory(TypeEventOperationHistory.CLICKSEEEXISTINGAGREEMENT);
        if (this.isLogged) {
            this.router.navigate(["pedidos-apoio"]);
            this.closeModal();
        } else {
            this.router.navigate(["pedidosApoio"]);
            this.closeModal();
        }
    }

    public closeModal() {
        this.newModalService.closeModal();
    }

    private setOperationHistory(operation: string) {
        this.paymentService.agreementHistory({ operation }).subscribe(() => {});
    }
}
